export const routeConfig = {
  home: { label: 'Forsiden', url: '/' },
  kjopeBolig: {
    label: 'Kjøpe bolig',
    url: 'https://privatmegleren.no/kjope-bolig?q=',
  },
  nybygg: { label: 'Nybygg', url: 'https://privatmegleren.no/nybygg' },
  naering: { label: 'Næring', url: 'https://privatmegleren.no/naering' },
  valuation: {
    label: 'Selge bolig / Verdivurdering',
    url: 'https://privatmegleren.no/verdivurdering',
  },
  mellomlinjene: {
    label: 'Mellom linjene',
    url: '/mellomlinjene',
  },
  kontoreriNaerheten: {
    label: 'Kontorer i nærheten',
    url: 'https://privatmegleren.no/kontorer/inarheten?q=',
  },
  officeBrokerSearch: {
    label: 'Kontor / Megler',
    url: 'https://privatmegleren.no/kontorer?alle',
  },
  raadvedsalg: {
    label: 'Råd ved salg av bolig',
    url: 'https://privatmegleren.no/content/selge-bolig-tips-rad',
  },
  hvaeretaks: {
    label: 'Hva er e-takst?',
    url: 'https://privatmegleren.no/content/e-takst-nokkelen-til-boligsalg',
  },
  naarlonnerdetseg: {
    label: 'Når lønner det seg å selge?',
    url: 'https://privatmegleren.no/content/kjope-eller-selge-forst',
  },
  boligbytte: {
    label: 'PrivatMegleren Boligbytte',
    url: 'https://privatmegleren.no/boligbytte-selge-eiendom',
  },
  kjop: {
    label: 'PrivatMegleren KJØP',
    url: 'https://privatmegleren.no/kjope-eiendom',
  },
  mittboligsalg: {
    label: 'PrivatMegleren Mitt boligsalg',
    url: 'https://privatmegleren.no/mittboligsalg',
  },
  kontorinaerheten: {
    label: 'Kontorer i nærheten',
    url: 'https://privatmegleren.no/kontorer/inarheten?q=',
  },
  settprispaa: {
    label: 'PrivatMegleren Sett Pris På',
    url: 'https://privatmegleren.no/verdivurdering-boligkalkulator',
  },
  omoss: {
    label: 'Om oss',
    url: 'https://privatmegleren.no/om-oss',
  },
  boligsok: {
    label: 'PM Boligsøk',
    url: 'https://privatmegleren.no/boligsok',
  },
  finansiering: {
    label: 'Finansiering',
    url: 'https://privatmegleren.no/finansiering-boliglan',
  },
  personvern: {
    label: 'Personvern',
    url: 'https://privatmegleren.no/personvern',
  },
  spoross: {
    label: 'Spør oss',
    url: 'https://privatmegleren.no/content/sporross',
  },
  stillinger: {
    label: 'Stillinger',
    url: 'https://privatmegleren.no/stillinger',
  },
  digitalMeeting: {
    label: 'Book et digitalt møte',
    url: 'https://privatmegleren.no/digitalt-mote-eiendom-salg',
  },
};
export type RouteConfig = typeof routeConfig;
